import React from 'react'
import styled from 'styled-components'
import { IconDownEmptyArrow, IconArrowLeft } from '@edulastic/icons'
import { FlexContainer } from '@edulastic/common'
import {
  white,
  themeColor,
  themeColorBlue,
  greyThemeDark1,
} from '@edulastic/colors'
import {
  Button,
  Label,
  ListBox,
  ListBoxItem,
  Popover,
  Select,
} from 'react-aria-components'
import { onEnterKeyPressHandler } from '../../../common/utils/helpers'

const SortMenu = ({ options, onSelect, sortBy, sortDir }) => {
  const sortBy2 = options.find((i) => i.value === sortBy)
  const handleMenuClick = (e) => onSelect(e.key, sortDir)
  const onSort = () =>
    onSelect(sortBy2.value, sortDir === 'desc' ? 'asc' : 'desc')

  const menu = (
    <StyledListBox onClick={handleMenuClick}>
      {options.map((option) => (
        <StyledListBoxItem id={option.value}>{option.text}</StyledListBoxItem>
      ))}
    </StyledListBox>
  )

  return (
    <FlexContainer>
      <StyledLabel data-cy="sort-button" onClick={onSort}>
        Sort by{' '}
        <StyledSortIcon
          role="button"
          aria-label={
            sortDir === 'desc'
              ? 'Change sort direction to ascending'
              : 'Change sort direction to descending'
          }
          tabIndex={0}
          dir={sortDir}
          onKeyDown={(e) => onEnterKeyPressHandler(e, onSort)}
        />
      </StyledLabel>
      <StyledSelect
        onSelectionChange={(selected) => {
          onSelect(selected, sortDir)
        }}
      >
        <StyledButton
          data-cy="sort-dropdown"
          tabIndex={0}
          aria-label={`Change sort field. Currently sorted by ${sortBy2?.text}`}
        >
          {sortBy2?.text}
          <StyledButtonIconSpan aria-hidden="true">
            <IconDownEmptyArrow />
          </StyledButtonIconSpan>
        </StyledButton>
        <Popover>{menu}</Popover>
      </StyledSelect>
    </FlexContainer>
  )
}

const StyledButton = styled(Button)`
  padding: 6px 15px;
  width: max-content;
  background: white;
  border-radius: 5px;
  border: 1px solid;
  cursor: pointer;
`

const StyledSortIcon = styled(IconArrowLeft)`
  transform: ${({ dir }) =>
    dir === 'desc' ? 'rotate(-90deg)' : 'rotate(90deg)'};
`

const StyledButtonIconSpan = styled.span`
  margin-left: 10px;
  margin-right: 0px !important;
  svg {
    margin-bottom: -2px;
  }
`

const StyledLabel = styled(Label)`
  min-width: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${greyThemeDark1};

  svg {
    fill: ${greyThemeDark1};
    height: 10px;
  }
`

const StyledSelect = styled(Select)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 100px;
  margin-left: 5px;
  button {
    border-color: ${themeColor};
  }
`

const StyledListBox = styled(ListBox)`
  background: white;
  font-size: 14px;
  width: 120px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: inherit;
  overflow: auto;
  forced-color-adjust: none;
  outline: none;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`

const StyledListBoxItem = styled(ListBoxItem)`
  padding: 5px 15px;
  cursor: pointer;
  &:hover,
  &:focus {
    background: ${themeColorBlue};
    color: ${white};
  }
`

export default SortMenu
